import { oasys } from '@0xtorch/core'
import { oasys as viemOasys } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createOasysChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}) =>
  createOasysChainCustom({
    client: createClient({
      chain: viemOasys,
      httpRpcs: oasysHttpRpcs,
    }),
    explorer: createBlockscout({
      name: 'Oasys-Hub Mainnet explorer',
      baseUrl: 'https://explorer.oasys.games/',
      apiBaseUrl: 'https://explorer.oasys.games/api',
      proxyUrl,
    }),
  })

type CreateOasysChainParameters = {
  client: Client
  explorer: Explorer
}

export const createOasysChainCustom = ({
  client,
  explorer,
}: CreateOasysChainParameters): Chain => ({
  id: 248,
  network: 'oasys',
  name: 'Oasys',
  nativeToken: {
    name: 'Oasys',
    symbol: 'OAS',
    decimals: 18,
    currency: oasys,
  },
  wrappedTokenAddresses: new Set([
    '0x5200000000000000000000000000000000000001',
  ]),
  explorer,
  client,
  blockTime: 15_000,
  coingeckoId: 'oasys',
  defillamaId: undefined,
})

export const oasysHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.mainnet.oasys.games',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 40_000n,
  },
  {
    url: 'https://oasys.api.pocket.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1024n,
  },
  // Endpoints is not working
  // {
  //   url: 'https://oasys-mainnet.rpc.grove.city/v1/167fa7a3',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 80_000n,
  // },
  // Endpoints is not working
  // {
  //   url: 'https://oasys-mainnet-archival.rpc.grove.city/v1/167fa7a3',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
]

export const oasysWebsocketRpcUrls: readonly string[] = [
  'wss://ws.mainnet.oasys.games	',
]
